import { RootState } from "store/store";
import { RequestStatus } from "types";

export const selectIsAuth = (state: RootState): boolean =>
  state.session.isAuthenticated;

export const selectSessionCredentials = (state: RootState): any | undefined =>
  state.session.credentials;

export const selectLogInStatus = (state: RootState): any =>
  state.session.status;

export const selectIsSessionConfirmed = (state: RootState): boolean =>
  state.session.isSessionConfirmed;

export const selectEmbedToken = (state: RootState): string =>
  state.session.embedToken;

export const selectOtpAuthUrl = (state: RootState): string | null =>
  state.session.otpAuthUrl;

export const selectTwoFAUpdateStatus = (state: RootState): RequestStatus =>
  state.session.twoFAUpdateStatus;

export const selectTwoFactorAuthEnabled = (state: RootState) : boolean => state.session.twoFactorAuthEnabled;

export const selectTwoFactorValidated = (state: RootState) : RequestStatus => state.session.twoFactorValidated;

export const selectLoginRequestStatus = (state: RootState) : RequestStatus => state.session.loginRequestStatus;